import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from 'react-router/dom'
import '@livekit/components-styles'
import './index.css'
import { initLocale } from './lib/i18n'
import { router } from './router'

// B9: the language is resolved before the first paint — the stored choice, or the browser's own.
initLocale()

const container = document.getElementById('root')
if (!container) throw new Error('#root is missing from index.html')

createRoot(container).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
)
